import { render, staticRenderFns } from "./CBProposalBurglarAlarms.vue?vue&type=template&id=09ee1f5a"
import script from "./CBProposalBurglarAlarms.vue?vue&type=script&lang=js"
export * from "./CBProposalBurglarAlarms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports